import Undefined from '../General/Undefined';
import AddValuesIntoArrayList from '../Forms/AddValuesIntoArrayList';
import SetDefaultTestsBySpecimenType from './SetDefaultTestsBySpecimenType';

const PopulateCraftedWithNewContents = (formDef, pageName, data, viewData) => {

    if (! Undefined(formDef.data.Crafted)) {
        for (const crafted of formDef.data.Crafted) {
            if (crafted.Name.toLowerCase() === pageName.toLowerCase()) {
                crafted.Contents = AddValuesIntoArrayList(crafted.Contents, data);
                formDef.craftedPageData = crafted.Contents;
            }
        }

        /*Handle setting up default tests and culture types defined by specimen types*/ 
        if (viewData !== undefined) {
            SetDefaultTestsBySpecimenType(formDef.data.Crafted, data, viewData.DefaultTests, "testselectionpage");
            SetDefaultTestsBySpecimenType(formDef.data.Crafted, data, viewData.DefaultCultures, "culturetypeselectionpage");
        }
    }
}

export default PopulateCraftedWithNewContents;



